<template>
  <master-crud-page
    master="fuel_type"
    title="Fuel Type"
    access="master_fuel_type"
    pk="mftyId"
    :columns="columns"
    :fields="fields"
  />
</template>

<script>
import MasterCrudPage from '@/components/master/MasterCrudPage';
import { formatDateTime } from '@/util/date';
import { DISPLAY_DATE } from '@/util/apiDatetime';

export default {
  name: 'MasterFuelType',
  components: { MasterCrudPage },
  data() {
    return {
      columns: [
        { key: 'mftyName', label: 'Fuel Type Name', align: 'left' },
        { key: 'mftyCreatedUserId', label: 'Created By', align: 'center' },
        {
          key: 'mftyCreatedTime',
          label: 'Created',
          align: 'center',
          formatter: (value) => formatDateTime(value, DISPLAY_DATE),
        },
      ],
      fields: [
        {
          key: 'mftyName',
          label: 'Fuel Type Name',
          type: 'text',
          required: true,
        },
      ],
    };
  },
};
</script>
